import React from 'react';
import styled from 'styled-components';

const LeftSection = styled.div`
  width: 50%;
  padding: 8px 0;
  border-right: 1px solid rgba(50, 65, 86, 0.4);
`;

export default LeftSection;
